import {
    Autocomplete,
    Checkbox,
    FormControlLabel,
    Tooltip,
} from '@mui/material'
import React from 'react'
import { MdEmail, MdHelpOutline } from 'react-icons/md'
import { Form, SelectStyle, TitleForm } from './styles'
import { Controller, UseFormReturn } from 'react-hook-form'
import classNames from 'classnames'
import { validateCnpjCpf } from '../../utils/validate'
import NumberFormat from 'react-number-format'
import { cnpjCpfMask, foneMask } from '../../utils/masks'

import {
    InitialContactProtocol,
    InputsFormStep1,
} from '../../Pages/CobrancaCriar/interfaces'

interface Props {
    submitFormStep1(inputs: InputsFormStep1): void
    formStep1: UseFormReturn<InputsFormStep1, any>
    saveContactAsFavs: boolean
    setSaveContactAsFavs(valor: boolean): void
    contacts: any[]
    setSelectedFav(contact: InitialContactProtocol): void
}

export default function Step1({
    formStep1: {
        control,
        register,
        formState: { errors },
        setValue,
        getValues,
    },
    saveContactAsFavs,
    setSaveContactAsFavs,
    contacts,
    setSelectedFav,
}: Props) {
    // const { register, control, handleSubmit, formState: { errors }, getValues, setValue, reset } = useForm<Inputs>()

    // const submit: SubmitHandler<Inputs> = async (inputs) => {

    //     // alterar o link data
    //     // passar para o proximo step
    // }

    // const getContacts = useCallback(async () => {
    //     try {
    //         const { data } = await api.get(`/contatos/${cnpj_cpf}`)
    //         // setContacts(data)
    //         const teste = data.map((contact: any) => ({
    //             value: contact,
    //             label: contact.nomeTitular
    //         }))
    //         setContacts(teste)
    //     } catch (error) {

    //     }
    // }, [cnpj_cpf])
    // useEffect(() => {
    //     getContacts()
    // }, [getContacts])

    return (
        <>
            <TitleForm className="text-2xl text-gray-900">
                Preencha os dados abaixo
            </TitleForm>
            <Form>
                <div className="flex items-center mt-2 mb-1">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={saveContactAsFavs}
                                onChange={(e, newValue) =>
                                    setSaveContactAsFavs(newValue)
                                }
                            />
                        }
                        label={'Salvar este contato como favorito'}
                    />
                    <Tooltip
                        title="Marque esta opção caso queria salvar estes dados como favoritos (ao selecionar um contato favorito e deixar essa opcão habilitada seu contato será atualizado com os novos dados)."
                        placement="top"
                    >
                        <span>
                            <MdHelpOutline size={18} />
                        </span>
                    </Tooltip>
                </div>
                <div className="input-group">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center sm:gap-x-5">
                        <div className="relative mb-3 sm:mb-2 w-full">
                            {/* <input type="text" id="name" autoComplete="username" {...register('nomeTitular', { required: 'O campo nome do pagador é obrigatório'})} className={classNames('rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1', {'ring-red-500 ring-2': errors.nomeTitular })} placeholder="Insira o nome do pagador" /> */}

                            <SelectStyle>
                                <Controller
                                    defaultValue=""
                                    name="nomeTitular"
                                    control={control}
                                    rules={{
                                        required:
                                            'O campo nome do titular é obrigatório',
                                        minLength: 3,
                                        maxLength: 100,
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            freeSolo
                                            value={{
                                                nomeTitular:
                                                    getValues('nomeTitular') ||
                                                    '',
                                            }}
                                            onChange={(event, newValue) => {
                                                // const value: string = newValue ? newValue[0] : ''
                                                setSelectedFav({
                                                    nomeTitular:
                                                        newValue?.nomeTitular,
                                                    cnpjPagador:
                                                        newValue?.numeroDocumentoTitular,
                                                    email: newValue?.email,
                                                    telefone:
                                                        newValue?.telefone,
                                                    id: newValue?.id,
                                                })
                                                // setNomePagadorInput({
                                                //     agencia: '',
                                                //     compe: '',
                                                //     email: '',
                                                //     id: '',
                                                //     ispb: '',
                                                //     nomeTitular: newValue?.nomeTitular,
                                                //     numeroConta: '',
                                                //     numeroDocumentoTitular: '',
                                                //     telefone: '',
                                                //     tipoConta: ''
                                                // })
                                                setSaveContactAsFavs(false)
                                            }}
                                            onInputChange={(event, value) => {
                                                // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                                // const inputEqualSomeContato = contatos.find((contato: any) => contato.nomeTitular === value)
                                                // if(!inputEqualSomeContato) {
                                                //     return field.onChange(value)
                                                // }
                                                // setNomePagadorInput({
                                                //     agencia: '',
                                                //     compe: '',
                                                //     email: '',
                                                //     id: '',
                                                //     ispb: '',
                                                //     nomeTitular: value,
                                                //     numeroConta: '',
                                                //     numeroDocumentoTitular: '',
                                                //     telefone: '',
                                                //     tipoConta: ''
                                                // })

                                                field.onChange(value)

                                                // setSelectedFav(inputEqualSomeContato)
                                            }}
                                            getOptionLabel={(option: any) => {
                                                return (
                                                    option.nomeTitular ?? option
                                                )
                                            }}
                                            // isOptionEqualToValue={(option, value) => {
                                            //     return option === value
                                            // }}
                                            disablePortal
                                            id="nomeTitular"
                                            options={contacts}
                                            sx={{
                                                width: '100%',
                                                fontFamily: 'Roboto',
                                                fontSize: '18px',
                                            }}
                                            renderInput={(params) => (
                                                <div
                                                    ref={params.InputProps.ref}
                                                >
                                                    <label
                                                        {...params.InputLabelProps}
                                                        className="text-gray-700 text-sm label block mb-2"
                                                    >
                                                        Nome do Cliente
                                                        <span className="text-red-500 required-dot">
                                                            *
                                                        </span>
                                                    </label>
                                                    <input
                                                        {...params.inputProps}
                                                        autoFocus
                                                        className={classNames(
                                                            'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                                            {
                                                                'ring-red-500 ring-2':
                                                                    errors.nomeTitular,
                                                            }
                                                        )}
                                                        placeholder="Insira o nome do cliente"
                                                    />
                                                </div>
                                            )}
                                        />
                                    )}
                                />
                                {/* <Controller defaultValue='' name='nomeTitular' control={control} rules={{ required: 'O campo nome do pagador é obrigatório'}} render={({ field: { value, ...field }}) => (
                                <CreatableSelect onBlur={field.onBlur} placeholder='Insira o nome do pagador' isClearable
                                
                                //     onCreateOption={(value) => {
                                //     setSelectedFav(initialContact)
                                //     field.onChange(value)
                                // }}
                                onChange={(e) => {
                                    if(e === null) {
                                        setSelectedFav(initialContact)
                                        setValue('nomeTitular', '')
                                        return
                                    }
                                    if(e.__isNew__) {
                                        handleCreateTemporaryContact(e.label)
                                        setSelectedFav(initialContact)
                                        field.onChange(e.label)
                                        return
                                    }
                                    const newValue = e.value
                                    setSelectedFav({
                                        nomeTitular: newValue?.nomeTitular,
                                        cnpjPagador: newValue?.numeroDocumentoTitular,
                                        email: newValue?.email,
                                        telefone: newValue?.telefone,
                                        id: newValue?.id
                                    })
                                    setSaveContactAsFavs(false)
                                }} options={contacts} />
                                )}/> */}
                            </SelectStyle>
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.nomeTitular.message}
                                    </span>
                                )}
                        </div>

                        {/* <CreatableSelect isClearable classNames={{
                            control: ({ isFocused }) => classNames(
                                isFocused && 'rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                            )
                        }} options={[]} /> */}

                        <div className="relative mb-2 w-full">
                            <label
                                htmlFor="cpf-cnpj"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                CPF/CNPJ
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <Controller
                                defaultValue=""
                                name="cnpjPagador"
                                control={control}
                                rules={{
                                    required: 'O campo CPF/CNPJ é obrigatório',
                                    validate: (value: string) =>
                                        validateCnpjCpf(value),
                                }}
                                render={({ field: { value, ...field } }) => (
                                    <input
                                        type="text"
                                        id="cpf-cnpj"
                                        {...field}
                                        value={cnpjCpfMask(value || '')}
                                        className={classNames(
                                            'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                            {
                                                'ring-red-500 ring-2':
                                                    errors.cnpjPagador,
                                            }
                                        )}
                                        placeholder="Insira o CPF/CNPJ do cliente"
                                    />
                                )}
                            />
                            {errors.cnpjPagador &&
                                errors.cnpjPagador.type === 'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.cnpjPagador.message}
                                    </span>
                                )}
                            {errors.cnpjPagador &&
                                errors.cnpjPagador.type === 'validate' && (
                                    <span className="text-red-500 text-sm">
                                        Cnpj ou Cpf inválido
                                    </span>
                                )}
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center sm:gap-x-5">
                        <div className="relative mb-3 sm:mb-2 w-full">
                            <label
                                htmlFor="email-with-icon"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                Email
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <div className="flex relative mt-1">
                                <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                    <MdEmail color="#6b7280" size={18} />
                                </span>
                                <input
                                    type="email"
                                    id="email-with-icon"
                                    {...register('email', {
                                        required: 'O campo email é obrigatório',
                                    })}
                                    className={classNames(
                                        'rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                        { 'ring-red-500 ring-2': errors.email }
                                    )}
                                    name="email"
                                    placeholder="Email do cliente"
                                />
                            </div>
                            {errors.email &&
                                errors.email.type === 'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.email.message}
                                    </span>
                                )}
                        </div>

                        <div className="relative mb-2 w-full">
                            <label
                                htmlFor="phone"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                Telefone
                            </label>

                            <Controller
                                defaultValue=""
                                name="telefone"
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, ...field } }) => (
                                    <input
                                        type="text"
                                        id="phone"
                                        {...field}
                                        value={foneMask(value || '')}
                                        className="rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                        placeholder="Telefone do cliente"
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div className="flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center sm:gap-x-5">
                        <div className="relative mb-3 sm:mb-2 w-full">
                            <label
                                htmlFor="value"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                Valor
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <div className="flex relative mt-1">
                                <span className="rounded-l-md inline-flex items-center px-3 border-t bg-white border-l border-b border-gray-300 text-gray-500 shadow-sm text-sm">
                                    R$
                                </span>
                                {/* <input type="text" id="value" className="rounded-r-lg appearance-none border border-gray-300 flex-none w-32 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" name="url" placeholder="17,00" /> */}
                                <Controller
                                    defaultValue=""
                                    name="valor"
                                    control={control}
                                    rules={{
                                        required: 'O campo valor é obrigatório',
                                        validate: (value: any) =>
                                            Number(value) > 0,
                                    }}
                                    render={({
                                        field: {
                                            value,
                                            onChange,
                                            ref,
                                            ...field
                                        },
                                    }) => (
                                        <NumberFormat
                                            {...field}
                                            value={value}
                                            className={classNames(
                                                'rounded-r-lg appearance-none border border-gray-300 flex-none w-32 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                                {
                                                    'ring-red-500 ring-2':
                                                        errors.valor,
                                                }
                                            )}
                                            id="valueLink"
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            thousandsGroupStyle="thousand"
                                            fixedDecimalScale
                                            decimalScale={2}
                                            allowNegative={false}
                                            placeholder="Ex: 10,90"
                                            prefix={''}
                                            onValueChange={({
                                                formattedValue,
                                                floatValue,
                                            }) => {
                                                setValue(
                                                    'valor',
                                                    floatValue || ''
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {errors.valor &&
                                errors.valor.type === 'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.valor.message}
                                    </span>
                                )}
                            {errors.valor &&
                                errors.valor.type === 'validate' && (
                                    <span className="text-red-500 text-sm">
                                        Valor inválido
                                    </span>
                                )}
                        </div>

                        <div className="relative mb-2 w-full">
                            <label
                                htmlFor="link-name"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                Nome da Cobrança
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                type="text"
                                id="link-name"
                                {...register('nomeLink', {
                                    required:
                                        'O campo nome do link é obrigatório',
                                })}
                                className={classNames(
                                    'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                    { 'ring-red-500 ring-2': errors.nomeLink }
                                )}
                                placeholder="Insira um nome para identificar a cobrança"
                            />
                            {errors.nomeLink &&
                                errors.nomeLink.type === 'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.nomeLink.message}
                                    </span>
                                )}
                        </div>
                    </div>

                    <div className="text-gray-700">
                        <label
                            htmlFor="link-description"
                            className="text-gray-700 text-sm label block mb-2"
                        >
                            Descrição da Cobrança
                        </label>
                        <textarea
                            {...register('observacao')}
                            className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            id="link-description"
                            placeholder="Digite uma observação ou descrição"
                            rows={5}
                            cols={40}
                        />
                    </div>
                </div>
            </Form>
        </>
    )
}
